var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var ComponentAttribute = require('./componentAttribute.js');

var ChipData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    //pad width for odd size pad which is different from others
    this.oddPadWidthMax = this.value("oddPadWidthMax", true);
    this.oddPadWidthMin = this.value("oddPadWidthMin", true);

    //component family if any
    this.componentFamily = this.value("componentFamily", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
 
};

lib_core.inherit(ChipData, DualRowPackageData);
lib_core.JsonParser.registerClass(ChipData, "ChipData");

module.exports = ChipData;

ChipData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["oddPadWidth"] = [this.oddPadWidthMin, this.oddPadWidthMax];
    this.validationMap["oddPadWidthMax"] = [this.oddPadWidthMax];
};

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
ChipData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();
	self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var motif = self.getMotif(),
        hPitch = self.component.C;
    
    //left pad
    var pad = motif.clone();
    var leftPadWidth = motif.getTopCopper().width();

    pad.move(new lib_geometry.Coord(-0.5 * hPitch, 0));
    pads.push(pad);

    //calculate right pad
    //both pads width are same if oddPadWidthMax is undefined or 0
    if (self.oddPadWidthMax && self.oddPadWidthMax()) {
        //right pad's either padWidthMin or padWidthMax is not same as that of left pad update pad size for right pad with new padWidthMin and padWidthMax
        if (self.oddPadWidthMax() !== self.padWidthMax() || self.oddPadWidthMin() !== self.padWidthMin()) {
            //update component with new padWidthMin and padWidthMax
            self.component.padWidthMax = self.oddPadWidthMax();
            self.component.padWidthMin = self.oddPadWidthMin();

            self.updateComponentCalculator();
        	motif = self.getMotif();
        }
    }

    //right pad
    pad = motif.clone();
    var rightPadWidth = motif.getTopCopper().width();
    var offset = hPitch / 2 - rightPadWidth / 2 + leftPadWidth / 2;

    pad.move(new lib_geometry.Coord(offset, 0));
    pads.push(pad);

    self.updatePads(pads, absolutePositions);

    return pads;
};

ChipData.prototype.getSilkscreen = function(pads) {
	var self = this;
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = self.getBodyForSilkscreen(),
    	leftPad = pads[0],
    	topLineY, bottomLineY,
        pathData;

    var topLineY = leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2;
    var bottomLineY = leftPad.getPos().y - leftPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;

    if(self.componentFamily() === ComponentAttribute.chipComponentFamily["POLARIZED_CAPACITOR"] ||
    	self.componentFamily() === ComponentAttribute.chipComponentFamily["POLARIZED_DIODE"] ||
    	self.componentFamily() === ComponentAttribute.chipComponentFamily["LED"]) {

    	/////////////////////////////////////////////////////////
    	//   Component Silkscreen for polarized component      //
    	/////////////////////////////////////////////////////////

	    var lineStartX = leftPad.getPos().x - leftPad.getTopCopper().width() / 2 - IPCRules.silkscreenClearance;

        pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, topLineY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, bottomLineY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, bottomLineY), PathType.LINE));
        silkscreen.push(pathData);
    } else {
    	/////////////////////////////////////////////////////////
    	//   Component Silkscreen for non-polarized component  //
    	/////////////////////////////////////////////////////////

    	//top line
        pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, topLineY), PathType.LINE));
        silkscreen.push(pathData);

        //bottom line
        pathData = new PathData(new lib_geometry.Coord(body.width / 2, bottomLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, bottomLineY), PathType.LINE));
        silkscreen.push(pathData);
    }

    return silkscreen;
}
